<template>
    <div class="rc">
        <div class="lt-left">
            <div ref="cmain1" class="cmain" :style="{ width: '460px', height: '220px' }"></div>
        </div>
    </div>
</template>

<script>
// import * as echarts from 'echarts';
export default {
    name: 'template.rightCent',
    data() {
        return {
            myChart: "",
            option: "",
            TmyChart: "",
            Toption: "",

        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {
        cDrawCircle() {
            var echarts = require('echarts');
            var TmyChart = echarts.init(this.$refs.cmain1);
            let yValue = ['门店名称01', '门店名称02', '门店名称03', '门店名称04', '门店名称05'];
            let xValue = [1130, 760, 730, 700, 600];
            var Toption = {
                color: ['#d84430'],
                tooltip: {
                    show: true
                },

                grid: {
                    top: '3%',
                    bottom: '0%',
                    left: '10px',
                    right: '5%'
                    // containLabel: false
                },
                xAxis: {
                    nameTextStyle: {
                        color: 'rgba(255, 255, 255, 0.8)',
                        align: 'right'
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        color: 'rgba(255, 255, 255, 0.8)'
                    },
                },

                yAxis: [
                    {
                        type: "category",
                        //升序
                        inverse: true,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        max: 4,// only the largest 3 bars will be displayed
                        axisLabel: {
                            show: true,
                            inside: true,
                            // margin: -5,
                            align: "left",
                            // overflow: "truncate",
                            verticalAlign: 'bottom',
                            lineHeight: 40,
                            color: '#A1A4AC',
                            fontSize: 16,
                            formatter: function (value, index) {   // 设置y轴文字拼接
                                return 'TOP. ' + (index + 1) + "    " + value

                            },
                        },
                        data: yValue,
                    },
                    //  {
                    //     inverse: true,
                    //     data: xValue,
                    //     align: "right",
                    //     overflow: "truncate",
                    //     verticalAlign: 'bottom',
                    //     lineHeight: 40,
                    //     axisLabel: {
                    //         inside: true,
                    //         textStyle: {
                    //             color: '#FAEC00',
                    //             fontSize: 14
                    //         },
                    //         formatter: '{c}' + '万元'
                    //     },
                    //     offset: 0,
                    //     splitLine: {
                    //         show: false
                    //     },
                    //     axisTick: {
                    //         show: false
                    //     },
                    //     axisLine: {
                    //         show: false
                    //     }
                    // }
                ],
                series: [
                    {
                        itemStyle: {
                            emphasis: {
                                barBorderRadius: [5, 5, 5, 5],
                            },
                            normal: {

                                barBorderRadius: [5, 5, 5, 5],
                                label: {

                                    show: false, //开启显示
                                },
                                color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                                    offset: 0,
                                    color: "#0C3F69 " // 0% 处的颜色 
                                }, {
                                    offset: 0.6,
                                    color: "#0A72FC" // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: "#0A72FC" // 100% 处的颜色
                                }], false)
                            },
                        },
                        type: "bar",
                        barWidth: 10,
                        backgroundStyle: {
                            color: '#1F2A30', // 背景条的颜色
                            barBorderRadius: [5, 5, 5, 5],
                        }, label: {
                            position: [10, 10], //在右显示
                            normal: {
                                align: 'right',
                                position: [410, -20],
                                show: true,
                                textStyle: {
                                    color: '#FAEC00',
                                    fontSize: 14,
                                },
                                formatter: '{c}' + '万元'
                            },
                            // textStyle: {
                            //     //数值样式
                            //     color: '#FAEC00',
                            //     fontSize: 14
                            // },

                        },

                        showBackground: true, // 【主要代码】
                        data: xValue,
                    }]

            };
            Toption && TmyChart.setOption(Toption);
            setInterval(function () {
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000)
        },
    },
    mounted() {
        this.$nextTick(() => {

            this.cDrawCircle(); //需要刷新的数据
        });
    },
};
</script>

<style scoped lang="scss">
.rc {
    width: 480px;
    height: 240px;
    display: flex;
    padding: 10px 0;
    position: relative;

}

.cmain {

    margin: 20px 0 4px;
    width: 480px;
    height: 240px;
}
</style>